<template>
  <div class="lenovo-invoice-entrance">
    <div class="invoice-module">
      <div class="invoice-title">
        <p>订单发票开具</p>
      </div>

      <div class="invoice-content">
        <ul class="title" :class="contentWidth ? '' : 'scroll-title'">
          <li>
            <span v-for="titleitem in invoiceTitleList" :key="titleitem.id">{{ titleitem.label }}</span>
          </li>
        </ul>
        <ul v-if="invoiceContentList.length > 0" class="content" :class="contentWidth ? '' : 'scroll-content'">
          <li v-for="contentItem in invoiceContentList" :key="contentItem.order_id">
            <span>
              {{ contentItem.order_id }}
              <div class="popover order-id-popover">
                <div class="triangles"></div>
                {{ contentItem.order_id }}
              </div>
            </span>
            <span>
              {{ contentItem.pay_setting_name }}
              <div class="popover order-title-popover">
                <div class="triangles"></div>
                {{ contentItem.pay_setting_name }}
              </div>
            </span>
            <span>{{ contentItem.order_timestamp }}</span>
            <span>{{ contentItem.order_fee }}</span>
            <span :class="contentItem.statusClass">
              <div class="invoice-status-clickable">
                <p class="text" @click="openInvoiceForm(contentItem)">{{ contentItem.status }}</p>
                <p v-if="[INVOICE_STATUS.FINISH_INVOICE].includes(contentItem.invoice_status)" class="triangle-down" :data-order-id="contentItem.order_id" @click.stop="toggleDropdown(contentItem)"></p>
              </div>
              <div v-if="([2, 4, 6, 7, 9].includes(contentItem.invoice_status))" class="popover" @click="$event.stopPropagation()">
                <div class="triangles" />
                {{ contentItem.statusPopoverCont }}
              </div>
              <div v-show="activeDropdownId === contentItem.order_id" :class="['download-dropdown', {'dropdown-up': isDropupMenu[contentItem.order_id]}]">
                <ul>
                  <li v-for="option in downloadOptions" :key="option.id" @click="downloadInvoice(contentItem, option.id === 1 ? 'pdf' : option.id === 2 ? 'ofd' : 'xml')">
                    {{ option.label }}
                  </li>
                </ul>
              </div>
            </span>
          </li>
        </ul>
        <ul v-else class="content no-data">
          暂无订单
        </ul>
      </div>
      <div class="invoice-description">
        预计在3个工作日内发票开具完成，届时您可在本页面下载发票
      </div>
    </div>

    <!-- 发票填写模块弹窗 -->
    <InvoiceForm :invoiceItem="invoiceItem" v-if="isShowInvoiceForm" @closeInvoiceForm="closeInvoiceForm" />
  </div>
</template>
<script>
import InvoiceForm from './InvoiceForm.vue'
import { getInvoiceListData } from '@/api/user'
import { formatDateFunc } from '@/utils/shared'
import electronTicket from '@/client/modules/electronTicket.js'
import client from '@/client/index.js'

// 开票状态
const INVOICE_STATUS = {
  NO_INVOICE: 1, // 未开票
  INVOICING: 2, // 开票中
  FINISH_INVOICE: 3, // 已完成开票
  EXPIRE_TIME: 4, // 已过期
  CANNOT_INVOICE: 6, // 不可开票
  HAS_INVOICE: 7, // 历史已开票
  HAS_REFUND: 9, // 已退款
}

// popover内容
const POPOVER_CONTENT = {
  INVOICING: '预计3个工作日开具成功',
  EXPIRE_TIME: '请联系客服人员',
  HAS_INVOICE: '已人工开票，请先查找邮箱，或联系客服人员'
}
export default {
  name: 'InvoiceEntrance',
  components: {
    InvoiceForm
  },
  data() {
    return {
      invoiceTitleList: [
        { id: 1, label: '订单号' },
        { id: 2, label: '订单详情' },
        { id: 3, label: '订单时间' },
        { id: 4, label: '金额' },
        { id: 5, label: '电子发票' }
      ],
      invoiceContentList: [],
      invoiceItem: {},
      isShowInvoiceForm: false, // 是否展示发票填写模块
      contentWidth: false,
      activeDropdownId: null, // 当前激活的下拉列表所属订单ID
      isDropupMenu: {}, // 记录每个菜单是否需要向上展示
      downloadOptions: [
        { id: 1, label: '下载.pdf格式' },
        { id: 2, label: '下载.ofd格式' },
        { id: 3, label: '下载.xml格式' }
      ],
      INVOICE_STATUS
    }
  },
  mounted() {
    this.getInvoiceList()
    this.reportFunc({ page_show: 1 })
    // 添加点击事件监听器，用于点击其他区域时关闭下拉菜单
    document.addEventListener('click', this.handleOutsideClick)
  },
  
  beforeDestroy() {
    // 组件销毁前移除事件监听器
    document.removeEventListener('click', this.handleOutsideClick)
  },

  methods: {
    // 获取用户订单发票列表
    getInvoiceList() {
      getInvoiceListData().then(res => {
        if (res.resp_common.ret === 0) {
          this.handleInvoiceData(res.invoice_list)
        }
      })
    },

    // 处理接口数据
    handleInvoiceData(invoiceList) {
      this.invoiceContentList = invoiceList.map(subItem => {
        const item = { ...subItem }
        item.order_timestamp = formatDateFunc(Number(item.order_timestamp), '-').toString()
        let status = ''
        let statusClass = ''
        switch (item.invoice_status) {
          case INVOICE_STATUS.INVOICING:
            status = '已提交开票申请'
            statusClass = 'invoicing'
            item.statusPopoverCont = POPOVER_CONTENT.INVOICING
            break
          case INVOICE_STATUS.FINISH_INVOICE:
            status = '下载发票'
            statusClass = 'finish-invoice'
            break
          case INVOICE_STATUS.EXPIRE_TIME:
            status = '已超期'
            statusClass = 'expire-time'
            item.statusPopoverCont = POPOVER_CONTENT.EXPIRE_TIME
            break
          case INVOICE_STATUS.CANNOT_INVOICE:
            status = '联系客服'
            statusClass = 'expire-time'
            item.statusPopoverCont = POPOVER_CONTENT.EXPIRE_TIME
            break
          case INVOICE_STATUS.HAS_INVOICE:
            status = '已开票'
            statusClass = 'expire-time'
            item.statusPopoverCont = POPOVER_CONTENT.HAS_INVOICE
            break
          case INVOICE_STATUS.HAS_REFUND:
            status = '存在退款'
            statusClass = 'expire-time'
            item.statusPopoverCont = POPOVER_CONTENT.EXPIRE_TIME
            break
          default:
            status = '未开发票'
            statusClass = 'no-invoice'
        }

        // 订单金额 分转元
        item.order_fee = item.order_fee / 100
        return {
          ...item,
          status,
          statusClass
        }
      })
      if (this.invoiceContentList.length <= 6) {
        this.contentWidth = true
      }
    },

    // 打开开具发票form弹窗
    openInvoiceForm(invoiceItemObj) {
      this.reportFunc({ page_show: 1, click: invoiceItemObj.invoice_status })
      if ([INVOICE_STATUS.FINISH_INVOICE].includes(invoiceItemObj.invoice_status)) {
        this.downloadInvoice(invoiceItemObj, 'pdf')
      } else if ([INVOICE_STATUS.NO_INVOICE, INVOICE_STATUS.INVOICING].includes(invoiceItemObj.invoice_status)) {
        // 未开票，开票中，弹窗
        this.invoiceItem = invoiceItemObj
        this.isShowInvoiceForm = true
      } else if ([INVOICE_STATUS.CANNOT_INVOICE, INVOICE_STATUS.HAS_INVOICE, INVOICE_STATUS.HAS_REFUND].includes(invoiceItemObj.invoice_status)) {
        // 联系客服
        window.open('https://wpa1.qq.com/0yNzTvH9?_type=wpa&qidian=true')
      }
    },

    // 关闭开具发票form弹窗
    closeInvoiceForm() {
      this.getInvoiceList()
      this.isShowInvoiceForm = false
    },

    toggleDropdown(invoiceItemObj) {
      if (this.activeDropdownId === invoiceItemObj.order_id) {
        this.activeDropdownId = null
      } else {
        this.activeDropdownId = invoiceItemObj.order_id
        
        // 添加延时以确保 DOM 已更新
        this.$nextTick(() => {
          // 获取当前点击的元素及相关元素
          // 获取当前点击的三角形图标
          const triggerEl = document.querySelector(`.triangle-down[data-order-id="${invoiceItemObj.order_id}"]`)
          const liElement = triggerEl ? triggerEl.closest('li') : null
          
          if (liElement) {
            // 在当前行内获取元素
            const dropdownEl = liElement.querySelector('.download-dropdown')
            const containerEl = document.querySelector('.content') || document.querySelector('.scroll-content')
          
            if (triggerEl && dropdownEl && containerEl) {
              // 获取元素位置信息
              const triggerRect = triggerEl.getBoundingClientRect()
              const containerRect = containerEl.getBoundingClientRect()
              const dropdownHeight = dropdownEl.offsetHeight
              
              // 计算向下和向上的可用空间
              const spaceBelow = containerRect.bottom - triggerRect.bottom
              const spaceAbove = triggerRect.top - containerRect.top
              
              // 判断当向下展示时是否超出容器底部
              const needsUpDirection = (spaceBelow < dropdownHeight) && (spaceAbove > spaceBelow)
              
              // 设置菜单方向
              this.$set(this.isDropupMenu, invoiceItemObj.order_id, needsUpDirection)
            }
          }
        })
      }
    },

    // 下载指定格式的发票
    async downloadInvoice(contentItem, format) {
      // 这里可以根据不同格式处理下载逻辑
      let url = contentItem.invoice_url

      // 根据选择的格式添加参数
      if (format === 'ofd') {
        url = contentItem.ofd_url || contentItem.invoice_url
      } else if (format === 'xml') {
        url = contentItem.xml_url || contentItem.invoice_url
      }

      // 打开下载链接
      if (url) {
        const result = await client.common.API.client_checkMethod('openBrowser')
        if (result.result) {
          client.common.API.client_openBrowser(url)
        } else {
          window.open(url)
        }
      } else {
        window.app.$toast('发票链接不存在，请联系客服', { duration: 2000 })
      }
      // 关闭下拉列表
      this.activeDropdownId = null
    },

    // 处理点击下拉菜单外部的事件
    handleOutsideClick(e) {
      // 如果没有打开的下拉菜单，则不需要处理
      if (this.activeDropdownId === null) return
      // 检查点击的元素是否是下拉菜单或其子元素
      const isClickedOnDropdown = e.target.closest('.download-dropdown')
      // 检查点击的元素是否是包含三角形图标的标记类名的点击区域
      const isClickedOnSpan = e.target.closest('.triangle-down')
      // 如果点击的既不是下拉菜单也不是包含三角形的整个span，则关闭下拉菜单
      if (!isClickedOnDropdown && !isClickedOnSpan) {
        this.activeDropdownId = null
      }
    },

    // 上报
    reportFunc(params) {
      electronTicket.REPORT.reportElectronicInvoiceClickandShow(params)
    }
  }
}
</script>
<style lang="scss" scoped>
.lenovo-invoice-entrance {
  color: #333;
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;

  .invoice-module {
    .invoice-title {
      display: flex;
      justify-content: space-between;
      height: 44px;

      p {
        margin: 20px 0 0 25px;
      }
    }
    .invoice-content {
      padding: 16px 25px 12px 25px;

      ul {
        color: #575757;
        font-size: 12px;
        background-color: #EFEFEF;
        height: 34px;

        &.title li {
          height: 100%;
        }
        li {
          display: flex;
          justify-content: space-around;
          align-items: center;

          span {
            display: inline-block;
            text-align: start;
          }
          span:nth-child(1) {
            padding-left: 12px;
            width: 135px;
            overflow: hidden;
            text-overflow: ellipsis;
            box-sizing: border-box;
            cursor: pointer;
          }
          span:nth-child(2) {
            width: 83px;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            white-space: nowrap;
            cursor: pointer;
          }
          span:nth-child(3) {
            width: 74px;
          }
          span:nth-child(4) {
            width: 50px;
          }
          span:nth-child(5) {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 96px;

            .triangle-down {
              display: inline-block;
              position: absolute;
              right: -18px;
              top: 50%;
              transform: translateY(-50%);
              width: 16px;
              height: 16px;
              cursor: pointer;
              text-align: center;
              line-height: 0;

              &:after {
                content: '';
                display: inline-block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                border-left: 4px solid transparent;
                border-right: 4px solid transparent;
                border-top: 6px solid currentColor;
              }
            }
            .download-dropdown {
              position: absolute;
              top: 20px;
              right: 0px;
              width: 95px;
              height: 84px;
              border: 1px solid #DDDDDD;
              box-shadow: 0px 2px 4px 0px #00000026;
              z-index: 1000;
              
              &.dropdown-up {
                top: auto;
                bottom: 20px;
              }

              ul {
                li {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 6px 11px;
                  height: 28px;
                  box-sizing: border-box;
                  color: #444444;
                  font-size: 12px;
                  background-color: #ffffff;
                  cursor: pointer;

                  &:hover {
                    background: #E9EAF2;
                  }
                }
              }
            }
          }
        }
      }
      .scroll-title {
        padding-right: 17px;
        box-sizing: border-box;
      }
      .content {
        width: 550px;
        height: 200px;
        color: #333;
        border-radius: 4px;
        background: #F8F8F8;
        overflow-y: auto;
        box-sizing: border-box;

        li {
          position: relative;
          padding-top: 12px;

          span:nth-child(5) {
            text-decoration: underline;
            cursor: pointer;
          }
          .no-invoice {
            color: #1F62EE;
          }
          .finish-invoice {
            color: #5CBF26;
          }
          .expire-time {
            color: #999;
          }
          .popover {
            pointer-events: none;
            display: none;
            position: absolute;
            top: 0px;
            right: 110px;
            z-index: 1;
            padding: 8px 8px 8px 10px;
            align-items: center;
            border-radius: 4px;
            color: #FFF;
            font-size: 12px;
            background-color: rgba(34, 34, 34, 0.80);
            white-space: nowrap;
            width: auto;

            .triangles {
              position: absolute;
              top: 10.5px;
              right: -5.7px;
              width: 0px;
              height: 0px;
              border-left: 6px solid rgba(34, 34, 34, 0.8);
              border-top: 6px solid transparent;
              border-bottom: 6px solid transparent;
            }
          }
          .expire-time {
            .popover {
              right: 90px;
            }
          }
          .order-id-popover {
            right: unset;
            left: 160px;

            .triangles {
              top: 10.5px;
              left: -5.7px;
              border-left: unset;
              border-right: 6px solid rgba(34, 34, 34, 0.8);
            }
          }
          .order-title-popover {
            right: unset;
            left: 270px;

            .triangles {
              top: 10.5px;
              left: -5.7px;
              border-left: unset;
              border-right: 6px solid rgba(34, 34, 34, 0.8);
            }
          }
          span:hover .popover {
            display: block;
          }
        }
      }
      .scroll-content {
        li:last-child {
          margin-bottom: 12px;
        }
      }
      .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
      }
    }
    .invoice-description {
      padding: 0 28px;
      color: #666;
      font-size: 12px;
    }
  }
}
/* 下拉菜单样式 */
.download-dropdown {
  position: absolute;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  width: 130px;
  top: 100%;
  right: 0;
}

/* 向上展示的下拉菜单 */
.dropdown-up {
  top: auto;
  bottom: 100%;
}

/* 确保三角形图标的父容器具有相对定位 */
.invoice-status-clickable {
  position: relative;
}
</style>
